import { StrategyRadar } from './StrategyRadar.tsx'
import { backendRuntimeConfig } from './runtimeConfig.ts'

export default function StrategyRadarApp() {
  return (
    <main className="radar-only-shell">
      <StrategyRadar
        backendEnabled={backendRuntimeConfig.enabled}
        chartTarget="binance"
        onOpenMarket={openBinanceSpotMarket}
      />
    </main>
  )
}

function openBinanceSpotMarket(symbol: string) {
  const quote = ['USDT', 'USDC', 'FDUSD'].find(candidate => symbol.endsWith(candidate)) ?? 'USDT'
  const base = symbol.slice(0, -quote.length)
  const url = `https://www.binance.com/en/trade/${encodeURIComponent(base)}_${encodeURIComponent(quote)}?type=spot`
  const opened = window.open(url, '_blank', 'noopener,noreferrer')
  if (opened) opened.opener = null
}
